module.exports = __webpack_public_path__ + "img/04.7ada6b1e.webp";